import { AccountRequestListPage } from "@/pages/account-request-list";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth_requeired/admin/account-requests/",
)({
  component: () => <AccountRequestListPage />,
});
